export default {"src":"/_next/static/media/iso.27cad8ca.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};